import {
    Cart,
    SerializationType,
    ProductType,
    BonusNightProduct,
} from '@/api/Cart/cart.interfaces';
import { fakeCartData } from '@/api/Cart/cart.fake';
import sum from 'lodash/sum';
import { Market } from '@shared/config/market/market.models';
import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';

const market: Market = getCurrentMarketSpecs();
const Currency = market.moneyFormat.currency;

export function getFakeSembonus(bonus: number[], cart: Cart) {
    const bonusProductId = 'SembonusId';

    const totalBonus = sum(bonus);

    const bonusProduct: BonusNightProduct = {
        Type: ProductType.Discount,
        Price: { Amount: -totalBonus, Currency },
        AppliedDiscount: null,
        Id: bonusProductId,
        $type: SerializationType.Sembonus,
        Description: 'Sembonus',
        Tags: [],
        AppliedBonusNights: bonus.map((b) => ({ Value: { Amount: b, Currency } })),
    };

    const products = cart.Products.filter(
        (p) => p.Id !== bonusProductId && p.Type !== 'Addon'
    );

    return {
        ...fakeCartData,
        Products: totalBonus > 0 ? products.concat(bonusProduct) : products,
    };
}
